import { AlertTriangle, Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";

interface LegacyEntityDeprecationBannerProps {
  legacyEntityName: string;
  onConvert: () => void;
  isConverting: boolean;
}

const LegacyEntityDeprecationBanner = ({
  legacyEntityName,
  onConvert,
  isConverting,
}: LegacyEntityDeprecationBannerProps) => (
  <div className="rounded-lg border border-amber-200 bg-amber-50/60 px-4 py-3">
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex min-w-0 flex-1 items-start gap-3 lg:pr-6">
        <span className="mt-0.5 inline-flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md border border-amber-200 bg-white/70 text-amber-700">
          <AlertTriangle className="h-3.5 w-3.5" aria-hidden="true" />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium leading-5 text-amber-950">
            This {legacyEntityName} view is being deprecated
          </p>
          <p className="mt-0.5 max-w-[52rem] text-pretty text-xs leading-5 text-amber-800/80">
            Tables are the new unified experience for evaluations, reports, and datasets. Convert
            this view to continue working in Tables.
          </p>
        </div>
      </div>

      <Button
        type="button"
        size="sm"
        variant="outline"
        className="h-8 w-full flex-shrink-0 gap-1.5 whitespace-nowrap border-amber-300 bg-white/70 px-3 text-xs font-medium text-amber-900 hover:bg-amber-100/70 hover:text-amber-950 sm:w-fit lg:w-auto"
        onClick={onConvert}
        disabled={isConverting}
      >
        {isConverting ? <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" /> : null}
        {isConverting ? "Converting..." : "Convert to Table"}
      </Button>
    </div>
  </div>
);

export default LegacyEntityDeprecationBanner;
